import { DIESEL_API_ROOT, EXTERNAL_API_ROOT, DIESEL_AUTH0_CLIENT_ID, DIESEL_AUTH0_DOMAIN, DIESEL_SEGMENT_WRITE_KEY, OPENAI_API_ROOT } from '../constants/commons'
/* Diesel config, all values set from generated env file
 *
 */
class DieselConfig {
  constructor () {
    // Slurp in the diesel env from the window. Should be set via the vars.js include.
    this.env = window.DIESEL_ENV || {}
    if (!DIESEL_AUTH0_CLIENT_ID || !DIESEL_AUTH0_DOMAIN || !DIESEL_API_ROOT || !DIESEL_SEGMENT_WRITE_KEY) {
      const message = 'Please define the required environment variables first: \n' +
              '\t`DIESEL_AUTH0_CLIENT_ID`\n' +
              '\t`DIESEL_AUTH0_DOMAIN`\n' +
              '\t`DIESEL_API_ROOT`\n' +
              '\t`DIESEL_SEGMENT_WRITE_KEY`\n'
      throw new Error(message)
    }
  }

  get Auth0ClientId () {
    return DIESEL_AUTH0_CLIENT_ID
  }

  get Auth0Domain () {
    return DIESEL_AUTH0_DOMAIN
  }

  get ApiRoot () {
    return DIESEL_API_ROOT
  }

  get ExternalApiRoot () {
    return EXTERNAL_API_ROOT
  }

  get OpenaiApiRoot () {
    return OPENAI_API_ROOT
  }

  get SegmentWriteKey () {
    return DIESEL_SEGMENT_WRITE_KEY
  }

  /**
   * How old the data should be before we request a refresh from the server. This is bypassed in
   * certain cases like when the user creates/deletes an item from a list. In those cases, the data
   * should be invalidated/refreshed immediately.
   */
  get DataStalenessCutoffMs () {
    return 1 * 60 * 60 * 1000
  }

  /* How many recommendations can a plan have after filtering before we push the filter to be server-side */
  get MaxRecosForServerSideFiltering () {
    return 100
  }

  /* Whether or not to return thumbnails */
  get PlanExportThumbnails () {
    if (this.env.DIESEL_PLAN_EXPORT_THUMBNAILS) {
      return !!this.env.DIESEL_PLAN_EXPORT_THUMBNAILS
    }
    return false
  }

  get PlanExportNumRecos () {
    return this.env.DIESEL_PLAN_EXPORT_NUM_RECOS || 1200
  }

  /* How many segments to display in the segment summary bar */
  get NumSegmentsToShow () {
    return this.env.DIESEL_NUM_SEGMENTS_TO_SHOW || 8
  }
}

const Config = new DieselConfig()

export default Config
